<div class="scroll-banner">
  <div class="scroll-banner__icon" [style.background]="iconBg">
    <mat-icon [style.color]="iconColor">{{ icon }}</mat-icon>
  </div>
  <div class="scroll-banner__heading">{{ heading }}</div>
  @if (scope) {
  <app-scope-chip [scope]="scope"></app-scope-chip>
  }
  <div class="card-scroll-wrap">
    @if (hasOverflow()) {
    <!-- Scroll toward the start of the list. Sits at the reading-start edge
         (left in LTR, right in RTL — flexbox mirrors it), so the chevron points
         that way too. -->
    <button
      type="button"
      class="card-scroll-btn"
      (click)="scroll('start')"
      aria-label="Scroll to start"
    >
      <mat-icon>{{ isRtl() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
    }
    <div
      #listEl
      class="scroll-banner__list"
      (scroll)="onScroll()"
      [style.--fade-l]="fadeLeft() ? fadeSize : '0px'"
      [style.--fade-r]="fadeRight() ? fadeSize : '0px'"
    >
      <ng-content></ng-content>
    </div>
    @if (hasOverflow()) {
    <!-- Scroll toward the end of the list (reading-end edge). -->
    <button
      type="button"
      class="card-scroll-btn"
      (click)="scroll('end')"
      aria-label="Scroll to end"
    >
      <mat-icon>{{ isRtl() ? 'chevron_left' : 'chevron_right' }}</mat-icon>
    </button>
    }
  </div>
</div>
